<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <h2>Projeto Configuração</h2>
    <h3>Admin</h3>
  </div>
  <div class="col-lg-2"></div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">
          <div class="info-page">
            <h3>Projeto Configuração Geral</h3>
          </div>
          <form [formGroup]="form" (ngSubmit)="salvar()">
            <input type="number" class="form-control" formControlName="id" hidden />

            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Percentagem Padrão do Status Ok:</label>
                <input type="number" class="form-control" formControlName="status_ok" step="1"/>
                <app-field-message [field]="fieldMessageRequired('status_ok')" [erros]="fieldErros('status_ok')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12">Percentagem Padrão do Status Atenção:</label>
                <input type="number" class="form-control" formControlName="status_warn" step="1"/>
                <app-field-message [field]="fieldMessageRequired('status_warn')" [erros]="fieldErros('status_warn')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12">Percentagem Padrão do Status Atraso:</label>
                <input type="number" class="form-control" formControlName="status_alert" step="1"/>
                <app-field-message [field]="fieldMessageRequired('status_alert')" [erros]="fieldErros('status_alert')"></app-field-message>
              </div>
            </div>

            <div class="hr-line-dashed"></div>
            <div class="form-group row d-flex justify-content-end">
              <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
                <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
                <button class="btn btn-primary" type="submit">Salvar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>